import title from './title';
import supplementalTitle from './supplementalTitle';
import vehicle from './vehicle';
import highlightedAttrsConfig from './highlightedAttrsConfig';

const root = {
	title,
	supplementalTitle,
	vehicle,
	highlightedAttrsConfig
};

export default root;
